export default __webpack_public_path__ + "img/Inter-MediumItalic_8bf30aa.woff2";